export default "__VITE_ASSET__7ccc9ce8__"